import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RuntimeConfigService } from './runtime-config.service';

export interface VersionInfo {
  version: string;
  commitSha: string;
  fullVersion: string;
}

const UNKNOWN_VERSION: VersionInfo = {
  version: '--',
  commitSha: '--',
  fullVersion: '--'
};

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private versionSubject = new BehaviorSubject<VersionInfo>(UNKNOWN_VERSION);
  public version$: Observable<VersionInfo> = this.versionSubject.asObservable();
  private loaded = false;

  constructor(
    private http: HttpClient,
    private runtimeConfig: RuntimeConfigService
  ) {}

  /** Fetches version info from the API once and caches it. */
  loadVersion(): void {
    if (this.loaded) return;
    this.loaded = true;

    const baseUrl = this.runtimeConfig.apiUrl || environment.apiUrl;
    this.http.get<VersionInfo>(`${baseUrl}/version`).subscribe({
      next: (info) => this.versionSubject.next(info),
      error: () => {
        // Graceful fallback — version display will show "--"
        console.warn('[VersionService] Could not fetch version info');
      }
    });
  }
}
